export const noAudio = { id: 'no-audio', label: 'No microphone' } as const;
export const noVideo = { id: 'no-video', label: 'No camera' } as const;

export const INVERTAL_DELAY = 1_500;
